/**
 *
 * @type {string}
 */
var $jsMoreInformationClass = '.js-more-information';

/**
 *
 */
$('.js-article .js-more').on('click', function(event) {

    event.preventDefault();

    var $article = $(this).closest('.js-article');

    var $moreInformation = $article.find($jsMoreInformationClass);

    $($jsMoreInformationClass).not($moreInformation).slideUp();
    $($jsMoreInformationClass).not($moreInformation).removeClass('open');

    if ($moreInformation.hasClass('open')) {
        $moreInformation.slideUp();
        $moreInformation.removeClass('open');
    } else {
        $moreInformation.addClass('open');
        $moreInformation.slideDown();

        window.scrollToObject($moreInformation);
    }

});


/**
 *
 */
$('.js-article .js-more-information .js-close').on('click', function() {

    event.preventDefault();

    var $moreInformation = $(this).closest('.js-more-information');
    $moreInformation.slideUp();
    $moreInformation.removeClass('open');
});
